import { render } from "./EditAcademy.vue?vue&type=template&id=7a86a602"
import script from "./EditAcademy.vue?vue&type=script&lang=js"
export * from "./EditAcademy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__